import React, { useEffect, useMemo } from "react";
import ModalComponent from "../../../components/modals";
import SimpleSelect from "../../../components/selects/simpleSelect";
import LaddaButton from "../../../components/buttons/laddaButton";
import { Grid } from "@mui/material";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import {
  impactData,
  probabilityData,
  vulnerabilityData
} from "../../../constants/selectData";
import { getRiskScore, getRiskLevelFromScore } from "../../createRisk/riskLevelLogic";
import { callApiAsync, postUpdateOpportunityValuation } from "../../../services/apiService";
import { icons } from "../../../constants";
import { getOpportunityLevelInfo } from "../tabDetails";
import { useSelector } from "react-redux";

const EditOpportunityValuationModal = ({
  open,
  handleClose,
  data,
  getOpportunityData,
  updateRiskupdateDate
}) => {
  const userData = useSelector((state) => state.userData.userData);
  const schema = yup.object().shape({
    impactLevel: yup.string().required("Requerido"),
    probability: yup.string().required("Requerido"),
    vulnerability: yup.string().required("Requerido")
  });

  const { control, handleSubmit, setValue, watch, formState: { errors } } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      impactLevel: "",
      probability: "",
      vulnerability: ""
    }
  });

  const watchImpact = watch("impactLevel");
  const watchProbability = watch("probability");
  const watchVulnerability = watch("vulnerability");

  const score = useMemo(() => {
    const i = parseInt(watchImpact, 10);
    const p = parseInt(watchProbability, 10);
    const v = parseInt(watchVulnerability, 10);
    if (!i || !p || !v) return 0;
    return getRiskScore(i, v, p);
  }, [watchImpact, watchProbability, watchVulnerability]);

  const levelFromScore = getRiskLevelFromScore(score);
  const opportunityLevelInfo = getOpportunityLevelInfo(levelFromScore.riskLeveltype);

  useEffect(() => {
    if (!open || !data) return;
    setValue("impactLevel", data.impactLevel != null ? String(data.impactLevel) : "");
    setValue("probability", data.probability != null ? String(data.probability) : "");
    setValue("vulnerability", data.vulnerability != null ? String(data.vulnerability) : "");
  }, [open, data, setValue]);

  const onSubmit = (formData) => {
    const payload = {
      id: data?.opportunityMonthId,
      impactLevel: formData.impactLevel,
      probability: formData.probability,
      vulnerability: formData.vulnerability,
      userId: userData.id
    };

    callApiAsync(
      () => postUpdateOpportunityValuation(payload),
      () => {
        if (updateRiskupdateDate) updateRiskupdateDate();
        getOpportunityData();
        handleClose();
      }
    );
  };

  return (
    <ModalComponent
      open={open}
      handleClose={handleClose}
      title="Editar valoración de la oportunidad"
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <p className="create-label ml-0">Impacto:</p>
            <SimpleSelect
              name="impactLevel"
              control={control}
              options={impactData}
              error={errors.impactLevel}
              hideLabel
              margin="0"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <p className="create-label ml-0">Vulnerabilidad:</p>
            <SimpleSelect
              name="vulnerability"
              control={control}
              options={vulnerabilityData}
              error={errors.vulnerability}
              hideLabel
              margin="0"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <p className="create-label ml-0">Probabilidad:</p>
            <SimpleSelect
              name="probability"
              control={control}
              options={probabilityData}
              error={errors.probability}
              hideLabel
              margin="0"
            />
          </Grid>
          <Grid item xs={12}>
            <div className="IHContainer align-center pillcontainer">
              <p className="create-label ml-0">Nivel de oportunidad:</p>
              <div className={`level ${opportunityLevelInfo?.class || "default-level"}`}>
                <p className={opportunityLevelInfo?.textClass || "default-level-text"}>
                  {opportunityLevelInfo?.text || "—"}
                </p>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} className="j-center mt-20">
            <LaddaButton type="submit" variant="contained">
              <div className="IHContainer align-center">
                <img className="btn-icon" src={icons.editWhite} alt="edit" style={{ marginRight: "8px" }} />
                <p className="button_text">Guardar</p>
              </div>
            </LaddaButton>
          </Grid>
        </Grid>
      </form>
    </ModalComponent>
  );
};

export default EditOpportunityValuationModal;
